import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { EnumAcaoRecurso } from '../../../../../app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from '../../../../../app/models/enum/recurso-perfil.enum';
import { IPermissaoModel } from '../../../../../app/models/permissao.model';
import { AuthService } from '../../../../../app/services/auth.service';
import { BaseListComponent } from "../../../../shared/components/base-list/base-list.component";
import { IOsaExecucaoFiltroModel, IOsaExecucaoModel } from '../../../../models/osa-execucao-model';
import { OsaExecucaoService } from '../../../../services/osa-execucao.service';
import { OsaService } from '../../../../services/osa.service';
import { AvaliacaoService } from 'src/app/services/avaliacao.service';
import { forkJoin, from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Component({
    selector: 'app-osa-execucao-list',
    templateUrl: './osa-execucao-list.component.html',
    styleUrls: ['./osa-execucao-list.component.scss']
})
export class OsaExecucaoListComponent extends BaseListComponent implements OnInit, AfterViewInit {
    public dataSource = new MatTableDataSource<any>([])
    public selectedModel: any;
    public semDados = false;
    public filtro: IOsaExecucaoFiltroModel = {} as IOsaExecucaoFiltroModel;
    public pageEvent: any;
    public totalItens: number;
    public numeroOsaObjeto: string;
    public displayedColumn: string[] = ['id', 'numeroOsa', 'numeroOpa', 'ug', 'statusUg', 'origemAuditoria', 'coordenacao', 'dataInicio', 'dataFim', 'tipoAuditoria', 'status', 'situacao'];
    public situacaoSelecionada: number = 2;
    public permissoes: IPermissaoModel;

    // NOVO: Propriedade para armazenar os filtros aplicados
    private filtrosAtivos: IOsaExecucaoFiltroModel = {} as IOsaExecucaoFiltroModel;

    @ViewChild(MatPaginator) paginator: MatPaginator
    @ViewChild('tabela1') public tabela1: MatSort;

    constructor(
        private osaExecucaoService: OsaExecucaoService,
        public route: ActivatedRoute,
        public toastr: ToastrService,
        public router: Router,
        public localeService: BsLocaleService,
        public matDialog: MatDialog,
        public authService: AuthService,
        private osaService: OsaService,
        private avaliacaoService: AvaliacaoService
    ) {
        super();
    }

    ngOnInit(): void {
        this.setarPermissoes();

        // NOVO: Escutar mudanças de filtros do componente de filtro
        this.osaExecucaoService.filtrosAplicados$.subscribe(filtros => {
        if (filtros) {
            this.filtrosAtivos = { ...filtros };
            this.aplicarFiltros();
        }
        });
    }

    private setarPermissoes(): void {

        this.permissoes = new IPermissaoModel();
        this.permissoes.consultar = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Consultar);
        this.permissoes.imprimir = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Imprimir);
        this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Visualizar);
        this.permissoes.executar = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Executar);
    }

    ngAfterViewInit() {
        this.configurarFiltro()
        this.obter();
    }

    sortData(sort) {
        this.filtro.colunaOrder = sort.active;
        this.filtro.direcao = sort.direction;
        this.obter();
    }

    public visualizar(id: number) {
        this.router.navigate([`/osa-execucao/${id}/visualizar`]);
    }

    public elaborar(id: number) {
        this.router.navigate([`/osa-execucao/${id}/executar`]);
    }

    public filtrarPorNumero() {
        this.selectedModel = null;
        var filtro: IOsaExecucaoFiltroModel = { numeroOsaObjeto: this.numeroOsaObjeto } as IOsaExecucaoFiltroModel;
        this.osaExecucaoService.obter(filtro);
    }

    public obter(): void {

        this.selectedModel = null;

        this.configurarFiltro(); // Garante que this.filtro está atualizado

        this.osaExecucaoService.obter(this.filtro).then(() => {
            this.osaExecucaoService.currentOsaExecucao.subscribe(res => {
                if (res.resultado && res.resultado.length > 0) {
                    this.dataSource = new MatTableDataSource<any>(res.resultado);
                    this.semDados = false;
                } else {
                    this.dataSource = new MatTableDataSource<IOsaExecucaoModel>([]);
                    this.semDados = true;
                }

                this.dataSource._updateChangeSubscription();
                this.totalItens = res.totalItens || 0;

                if (this.tabela1) {
                    this.dataSource.sort = this.tabela1;
                }
            });
        });
    }

    private configurarFiltro() {
        const situacao = this.situacaoSelecionada ?? 2;
        this.filtro.ativo = situacao === 2 ? true : situacao === 3 ? false : null;
        if (this.paginator) {
            this.filtro.pagina = this.paginator.pageIndex + 1;
            this.filtro.itensPorPagina = this.paginator.pageSize;
        }
    }

    pageChanged(e) {

        if (!this.filtro) {
        this.filtro = {} as IOsaExecucaoFiltroModel;
        }

        this.filtro.pagina = e.pageIndex + 1;
        e.pageIndex = this.filtro.pagina;
        this.filtro.itensPorPagina = e.pageSize;

        const temFiltroNumeroOsaObjeto = this.numeroOsaObjeto && this.numeroOsaObjeto.toString().trim() !== '';
        const temFiltrosAvancados = this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0;

        if (temFiltrosAvancados) {
            const { pagina, itensPorPagina } = this.filtro;
            this.filtro = {
                ...this.filtrosAtivos,
                pagina,
                itensPorPagina
            };
        }

        if (temFiltroNumeroOsaObjeto) {
            this.filtro.numeroOsaObjeto = this.numeroOsaObjeto;
        }

        this.obter();
    }







    public selecionar(item: any) {
        item.selecionado = !item.selecionado;
        if (item.selecionado) {

            this.selectedModel = item;
            // regra comentada para facilitar os testes  
            //this.permissoes.executar = ((this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Executar)) && (this.authService.usuario.id === this.selectedModel.osa?.auditorId));

        } else {

            if (this.selectedModel === item) {
                this.selectedModel = null;
            }
        }
    }

    public modelsSelected(): Array<any> {
        let retorno = this.dataSource.data.filter(x => x.selecionado === true);
        return retorno;
    }


    public async imprimir(id: number) {
        try {
            const response = await this.avaliacaoService.obter(15, id);

            if (response?.dados !== undefined && response?.dados !== null) {
                // Pega o id da primeira ação da primeira data
                const primeiraAcaoId = response.dados.datas?.[0]?.acoes?.[0]?.id;

                if (primeiraAcaoId) {
                    const url = `${window.location.origin}/imprimir-linha-do-tempo/${primeiraAcaoId}/tipo-trabalho/execucao`;
                    window.open(url, '_blank');
                } else {
                    this.exibirMensagemAlerta('Não foi possível obter o ID da ação para impressão.');
                }
            } else {
                this.exibirMensagemAlerta('Não há dados disponíveis para impressão.');
            }
        } catch (error) {
            this.exibirMensagemErro('Erro ao tentar imprimir. Tente novamente.');
            console.error('Erro ao obter dados para impressão:', error);
        }
    }

    public imprimirRelatorioConsolidado() {
        const ids = this.modelsSelected().map(x => x.id).toString();
        const listaIds = ids
            .split(',')
            .map(id => Number(id.trim()))
            .filter(id => !isNaN(id));

        const requests = listaIds.map(id =>
            from(this.avaliacaoService.obter(15, id)).pipe(
                catchError(() => of(null)) // evita quebrar tudo se uma Promise falhar
            )
        );

        forkJoin(requests).subscribe(responses => {

            const primeiraAcaoIds: number[] = [];

            responses.forEach(response => {
                if (response?.dados?.datas?.length) {
                    const primeiraAcaoId =
                        response.dados.datas?.[0]?.acoes?.[0]?.id;

                    if (primeiraAcaoId) {
                        primeiraAcaoIds.push(primeiraAcaoId);
                    }
                }
            });

            if (primeiraAcaoIds.length === 0) {
                this.exibirMensagemAlerta(
                    'Nenhum dos itens selecionados possui dados para impressão.'
                );
                return;
            }

            const todosIdsPrimeiraAcaoId = primeiraAcaoIds.join(',');

            const url = `${window.location.origin}/imprimir-consolidado-linha-do-tempo/${todosIdsPrimeiraAcaoId}/tipo-trabalho/execucao`;
            window.open(url, '_blank');
        });
    }

    public botaoImpressaoColetivaHidden(): boolean {
        return !this.permissoes.imprimir || this.modelsSelected().length <= 1;
    }

    //-> metodo criado pra fazer testes
    //public teste(id: number) {
    //    this.osaExecucaoService.homologarTeste(id);
    //}

    private aplicarFiltros(): void {

        this.filtro = { ...this.filtrosAtivos };
        this.filtro.pagina = 1;
    }    

}
